import { Dialog, DialogContent, DialogClose } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';

interface Props {
  open: boolean;
  onClose: () => void;
}

const OptimizationTutorialOverlay = ({ open, onClose }: Props) => {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent noCloseBtn className="w-[360px] p-[30px]">
        <div className="flex flex-col items-start">
          <div className="text-gr-900 Title3S18">상품 진단을 진행중이에요</div>
          <div className="mt-[4px] text-gr-700 Body5M14">
            새 탭에서 확장프로그램이 상품을 분석하고 있어요. <br />
            분석이 완료되면 목록에 결과가 나타나요.
          </div>
          <div className="mt-[20px] flex w-full">
            <DialogClose asChild>
              <Button variant="default" className="h-[48px] flex-1">
                확인
              </Button>
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OptimizationTutorialOverlay;
